var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "h8x3re5zna",
    width: 35,
    height: 25,
    x: 0,
    y: 0,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "82dleee81b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h8x3re5zna"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#h8x3re5zna"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A17A7",
    d: "M0 0H35V25H0z",
    mask: "url(#82dleee81b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.342 16.667H0V8.333h8.342L-3.468.368l1.865-2.764L13.333 7.68v-9.346h8.334V7.68L36.603-2.396 38.467.368l-11.81 7.965H35v8.334h-8.342l11.81 7.965-1.865 2.764L21.667 17.32v9.346h-8.334V17.32L-1.603 27.396l-1.864-2.764 11.81-7.965z",
    mask: "url(#82dleee81b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DB1F35",
    strokeLinecap: "round",
    strokeWidth: 0.667,
    d: "M23.335 7.915L39.167-2.5",
    mask: "url(#82dleee81b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DB1F35",
    strokeLinecap: "round",
    strokeWidth: 0.667,
    d: "M25.016 26.688l14.192-9.566",
    mask: "url(#82dleee81b)",
    transform: "matrix(1 0 0 -1 0 43.81)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DB1F35",
    strokeLinecap: "round",
    strokeWidth: 0.667,
    d: "M10.007 7.888L-4.797-2.089",
    mask: "url(#82dleee81b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DB1F35",
    strokeLinecap: "round",
    strokeWidth: 0.667,
    d: "M11.613 27.888l-16.41-10.882",
    mask: "url(#82dleee81b)",
    transform: "matrix(1 0 0 -1 0 44.894)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6273E",
    d: "M0 15L15 15 15 25 20 25 20 15 35 15 35 10 20 10 20 0 15 0 15 10 0 10z",
    mask: "url(#82dleee81b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.1f4c160ceacf2f4e4790c1a3111d6a67.svg";
export { ForwardRef as ReactComponent };